module.exports = __webpack_public_path__ + "img/thumbnail_NileMonitor_f_albino.e0eb9912.png";